import {Injectable} from "@angular/core";
import {SharedLogic} from "./shared.logic";
import {NestApiProvider} from "../../shared/nestjs/nest-api";
import {GetCompanyData} from "../../shared/nestjs/gd-only/dto/sf-company.dto";

@Injectable()
export class CarrierLogic {
  constructor(
    private sharedLogic: SharedLogic,
    private nestApiProvider: NestApiProvider,
  ) {
  }

  async getCompany(companyId: number): Promise<GetCompanyData> {
    return new Promise<GetCompanyData>(async (resolve, reject) => {
      const isGoPathNewExist = await this.nestApiProvider.isGoPathNewExist();
      try {
        if (isGoPathNewExist) {
          const result = await this.sharedLogic.getCompanyNest({companyId});
          resolve(result.data)
        } else {
          const result = await this.sharedLogic.getCompanyLB({companyId});
          resolve(result[0])
        }
      } catch (e) {
        reject(e);
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/component-logic/carrier.logic.ts